import { Box, MultiSelectCheckbox, Text, TextFieldAppearance, TextFieldSize } from '@bechtel/gds';
import { WeldProcedure as WeldProcedureType } from '@bechtel/types';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useField } from 'formik';
import { filter, isEqual, some } from 'lodash';
import { FC } from 'react';
import { WeldProcedureProps } from './types';

export const SelectedWPS = ({
  selectedItemCount,
  totalItemCount,
}: {
  selectedItemCount: number;
  totalItemCount: number;
}) => {
  return (
    <Box pl={{ sm: '500' }}>
      <Text size="300" family="graphik" color="grey.1000" style={{ whiteSpace: 'nowrap' }}>
        {isEqual(selectedItemCount, totalItemCount)
          ? `${t`All WPS `}`
          : selectedItemCount > 0
            ? `${t`${selectedItemCount} WPS`}`
            : `${t`Select WPS`}`}
      </Text>
    </Box>
  );
};

const WPSItem = ({ item }: { item: WeldProcedureType }) => {
  return (
    <Box flexDirection={{ sm: 'row' }} alignItems={{ sm: 'center' }}>
      <Text size="400" family="graphik" color="grey.1000">
        {item?.procedure}
      </Text>
    </Box>
  );
};

export const WeldProcedure: FC<WeldProcedureProps> = ({ items, fieldName }) => {
  const { i18n } = useLingui();
  const [field, meta, helpers] = useField(fieldName);
  const { setValue } = helpers;
  const { value: weldProcedures } = field;
  const initiatSelectedItems = filter(items, (item) => {
    return some(weldProcedures, { id: item.id });
  });
  return (
    <Box flexDirection={{ sm: 'column' }} px={{ sm: '450' }} py={{ sm: '500' }}>
      <MultiSelectCheckbox
        initialSelectedItems={initiatSelectedItems}
        showSearchBar={false}
        items={items}
        itemComponent={WPSItem}
        selectedComponent={SelectedWPS}
        size={TextFieldSize.LARGE}
        showSelectAll={false}
        appearance={TextFieldAppearance.NORMAL}
        placeholder={t`Select Weld Procedure`}
        confirmSelection={true}
        onSelectedItemsChange={(selectedItem) => {
          setValue(selectedItem);
        }}
      />

      {meta.touched && meta.error ? (
        <Box pt={{ sm: '200' }}>
          <Text color="bechtel.red">{i18n._(meta.error)}</Text>
        </Box>
      ) : null}
    </Box>
  );
};
